export default "__VITE_PUBLIC_ASSET__7ede7d7e__"